import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get('/auth/check/');
      if (res.data.authenticated) {
        setUser(res.data.user);
      } else {
        setUser(null);
      }
    } catch {
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (username, password) => {
    await api.get('/auth/csrf/');
    const res = await api.post('/auth/login/', { username, password });
    setUser(res.data);  // login returns profile directly, not {user: profile}
    return res.data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout/'); } catch {}
    setUser(null);
  };

  const register = async (data) => {
    await api.get('/auth/csrf/');
    const res = await api.post('/auth/register/', data);
    setUser(res.data);  // register returns profile directly
    return res.data;
  };

  const refreshProfile = async () => {
    try {
      const res = await api.get('/auth/profile/');
      setUser(res.data);
    } catch {}
  };

  const value = {
    user,
    loading,
    isAuthenticated: !!user,
    isAdmin: user?.is_staff || false,
    isSuperUser: user?.is_superuser || false,
    isGestoria: user?.is_gestoria || false,
    // Envío de correo de bienvenida (ENVIO_CORREO_ACTIVO en el servidor).
    // Desactivado, el panel no muestra el correo ni los estados de envío.
    envioCorreoActivo: user?.envio_correo_activo || false,
    login,
    logout,
    register,
    refreshProfile,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
